<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>

    <!--  Banner Starts Here   -->
    <section class="inner_banner">
      <div class="container_large">
        <div class="inner_banner_content">
          <div class="back_step">
            <!-- <a href="#"  @click="$router.go(1)"> -->
            <a href="#" @click="backStep()" style="font-size: 22px">
              <i class="fas fa-chevron-left"></i> Back
            </a>
          </div>
          <h1>Your <span>Bag</span></h1>
        </div>
      </div>
    </section>
    <!--  Banner Ends Here   -->

    <!--   Main Content Start Here   -->
    <main>
      <section class="default_wraper">
        <div class="container_large">
          <div class="customer_note cart_note">
            <i class="fi fi-rr-info"></i>
            <ul>
              <li>
                For best estimates we recommend reviewing your items before
                proceeding to Checkout.
              </li>
              <li>
                <strong> Pickup: </strong>
                <!-- If it is separate delivery, wash and fold keys would use. Otherwise, combined params will be used -->
                <span v-if="orderObj.is_individual">
                  {{ this.orderObj.pickups["wash"].pickup_date | formatDate }}
                  {{ this.orderObj.pickups["wash"].start_time_split }} -
                  {{ this.orderObj.pickups["wash"].end_time }}
                </span>
                <span v-if="!orderObj.is_individual">
                  {{
                    this.orderObj.pickups["combined"].pickup_date | formatDate
                  }}
                  {{ this.orderObj.pickups["combined"].start_time_split }} -
                  {{ this.orderObj.pickups["combined"].end_time }}
                </span>
              </li>
              <li v-if="wash_products && wash_products.length">
                <strong>Drop Off:</strong>

                <!-- If it is separate delivery (+ not same day), wash and fold keys would use. Otherwise, combined params will be used -->
                <span
                  v-if="orderObj.is_individual && !orderObj.is_wash_premium"
                >
                  {{
                    this.orderObj.delivery["wash"].delivery_date | formatDate
                  }}
                  {{ this.orderObj.delivery["wash"].start_time_split }} -
                  {{ this.orderObj.delivery["wash"].end_time }}
                </span>

                <!-- If it is separate delivery (WITH same day :: premium), wash and fold keys would use. Otherwise, combined params will be used -->
                <span v-if="orderObj.is_individual && orderObj.is_wash_premium">
                  <!-- using pickup as delivery becuase its the Same_Day or premium delivery -->
                  {{ this.orderObj.pickups["wash"].pickup_date | formatDate }}
                  {{ this.orderObj.delivery["wash"].start_time_split }} -
                  {{ this.orderObj.delivery["wash"].end_time }}
                </span>

                <span v-if="!orderObj.is_individual">
                  {{
                    this.orderObj.delivery["combined"].delivery_date
                      | formatDate
                  }}
                  {{ this.orderObj.delivery["combined"].start_time_split }} -
                  {{ this.orderObj.delivery["combined"].end_time }}
                </span>

                <span>(Wash & Fold)</span>
              </li>
              <!-- Here, 2nd delivery option will only be displayed if order is individual type (not together delivery) && there is some data set in dryclean or tailoring -->
              <li
                v-if="
                  orderObj.is_individual &&
                  ((dry_clean_products && dry_clean_products.length) ||
                    (tailoring_products && tailoring_products.length))
                "
              >
                <strong>Drop Off:</strong>
                <span
                  >{{
                    this.orderObj.delivery["dry_clean"].delivery_date
                      ? this.orderObj.delivery["dry_clean"].delivery_date
                      : this.orderObj.delivery["tailoring"].delivery_date
                        | formatDate
                  }}
                  {{
                    this.orderObj.delivery["dry_clean"].start_time_split
                      ? this.orderObj.delivery["dry_clean"].start_time_split
                      : this.orderObj.delivery["tailoring"].start_time_split
                  }}
                  -
                  {{
                    this.orderObj.delivery["dry_clean"].end_time
                      ? this.orderObj.delivery["dry_clean"].end_time
                      : this.orderObj.delivery["tailoring"].end_time
                  }}</span
                >

                <span>(Dry Cleaning &/or Tailoring)</span>
              </li>
            </ul>
          </div>

          <form
            @submit.prevent="formSbmit()"
            @keydown.enter.prevent.self
            autocomplete="disabled"
          >
            <div class="row">
              <div class="col-md-12 col-lg-8">
                <div class="cart_holder">
                  <!-- Wash & Fold -->
                  <div class="cart_row">
                    <h2>Wash & Fold</h2>
                    <div v-if="wash_products && wash_products.length">
                      <div
                        class="cart_item"
                        v-for="data in wash_products"
                        :key="data.id"
                      >
                        <ul>
                          <li>
                            <h3>
                              {{ data.name ? data.name : "" }}
                              <!-- <span v-if="data.id == 10001">(per lb)</span> -->
                              <span v-if="data.id == 288">(per lb)</span>
                            </h3>
                          </li>
                          <li>
                            <!-- <select
                              class="form-select"
                              v-model="wash_product_weight[data.id]"
                              @change="changeWash(data.id)"
                              v-if="data.id == 288"
                            >
                              <option value="1">1 lbs</option>
                              <option value="5">5 lbs</option>
                              <option value="10">10 lbs</option>
                              <option value="15">15 lbs</option>
                              <option value="20">20 lbs</option>
                              <option value="25">25 lbs</option>
                              <option value="30">30 lbs</option>
                              <option value="35">35 lbs</option>
                              <option value="40">40 lbs</option>
                              <option value="45">45 lbs</option>
                              <option value="50">50 lbs</option>
                              <option value="55">55 lbs</option>
                              <option value="60">60 lbs</option>
                              <option value="65">65 lbs</option>
                              <option value="70">70 lbs</option>
                              <option value="75">75 lbs</option>
                              <option value="80">80 lbs</option>
                              <option value="85">85 lbs</option>
                              <option value="90">90 lbs</option>
                              <option value="95">95 lbs</option>
                              <option value="100">100 lbs</option>
                            </select> -->
                            <!-- <div v-if="data.id != 10001"> -->
                            <!-- <div v-if="data.id != 288"> -->

                            <div>
                              <button
                                type="button"
                                class="count_btn decrement"
                                @click.prevent="
                                  changeQty(data.id, 'wash', 'descrease')
                                "
                              >
                                <i class="fi fi-rr-minus-small"></i>
                              </button>
                              <input
                                type="text"
                                class="item_count"
                                v-model="wash_product_weight[data.id]"
                              />
                              <button
                                type="button"
                                class="count_btn increment"
                                @click.prevent="
                                  changeQty(data.id, 'wash', 'increase')
                                "
                              >
                                <i class="fi fi-rr-plus-small"></i>
                              </button>
                            </div>
                          </li>
                          <li>
                            <strong
                              >${{
                                data.total_price
                                  ? parseFloat(data.total_price).toFixed(2)
                                  : ""
                              }}
                            </strong>
                          </li>
                          <li>
                            <button
                              type="button"
                              @click="deleteModal('wash', data.id)"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="27"
                                height="31.5"
                                viewBox="0 0 27 31.5"
                              >
                                <g
                                  id="delete"
                                  transform="translate(-4.5 -2.25)"
                                >
                                  <path
                                    id="Path_64"
                                    data-name="Path 64"
                                    d="M13.5,13.5h2.25V27H13.5Z"
                                    fill="#9cabc4"
                                  />
                                  <path
                                    id="Path_65"
                                    data-name="Path 65"
                                    d="M20.25,13.5H22.5V27H20.25Z"
                                    fill="#9cabc4"
                                  />
                                  <path
                                    id="Path_66"
                                    data-name="Path 66"
                                    d="M4.5,6.75V9H6.75V31.5A2.25,2.25,0,0,0,9,33.75H27a2.25,2.25,0,0,0,2.25-2.25V9H31.5V6.75ZM9,31.5V9H27V31.5Z"
                                    fill="#9cabc4"
                                  />
                                  <path
                                    id="Path_67"
                                    data-name="Path 67"
                                    d="M13.5,2.25h9V4.5h-9Z"
                                    fill="#9cabc4"
                                  />
                                </g>
                              </svg>
                            </button>
                          </li>
                        </ul>
                      </div>

                      <!-- displaying wash n fold products inline -->
                      <h3>Add Commonly Selected Items</h3>
                      <div class="my_items my_tailored">
                        <div class="row">
                          <div
                            class="col-6 col-md-4 col-lg-3"
                            v-for="data in wash_clean_products"
                            :key="data"
                          >
                            <div
                              class="item_col"
                              @click.prevent="
                                cartProducts(
                                  data,
                                  data.quantity,
                                  'wash',
                                  'wash_product'
                                );
                                activate(data.id, 'wash');
                              "
                            >
                              <!-- <div class="item_img">
                                <img
                                  :src="
                                    data.ic
                                      ? 'https://s3.us-east-2.amazonaws.com/cleancloudapp/ic/b/' +
                                        data.ic
                                      : '/src/assets/images/image-placeholder.png'
                                  "
                                  class="img-fluid"
                                  alt=""
                                />
                              </div> -->
                              <div class="item_col_content">
                                <span>
                                  $
                                  {{
                                    wash_product_weight[data.id]
                                      ? parseFloat(
                                          wash_product_weight[data.id] *
                                            data.price
                                        ).toFixed(2)
                                      : data.price
                                  }}</span
                                >
                                <ul>
                                  <li>
                                    <input
                                      type="text"
                                      class="item_count"
                                      v-model="wash_product_weight[data.id]"
                                    />
                                    {{ data.name ? data.name : "" }}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- wash n fold products inline display -->
                    </div>
                    <div class="cart_item" v-else>
                      No item added for this category
                    </div>
                  </div>
                  <!-- Dry Cleaning -->
                  <div class="cart_row">
                    <h2>Dry Cleaning</h2>
                    <div v-if="dry_clean_products && dry_clean_products.length">
                      <div
                        class="cart_item"
                        v-for="data in dry_clean_products"
                        :key="data.id"
                      >
                        <ul>
                          <li>
                            <h3>{{ data.name ? data.name : "" }}</h3>
                          </li>
                          <li>
                            <button
                              type="button"
                              class="count_btn decrement"
                              @click.prevent="
                                changeQty(data.id, 'dry_clean', 'descrease')
                              "
                            >
                              <i class="fi fi-rr-minus-small"></i>
                            </button>
                            <input
                              type="text"
                              class="item_count"
                              v-model="dry_clean_products_quantity[data.id]"
                            />
                            <button
                              type="button"
                              class="count_btn increment"
                              @click.prevent="
                                changeQty(data.id, 'dry_clean', 'increase')
                              "
                            >
                              <i class="fi fi-rr-plus-small"></i>
                            </button>
                          </li>
                          <li>
                            <strong
                              >${{
                                data.total_price
                                  ? parseFloat(data.total_price).toFixed(2)
                                  : ""
                              }}
                            </strong>
                          </li>
                          <li>
                            <button
                              type="button"
                              @click="deleteModal('dry_clean', data.id)"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="27"
                                height="31.5"
                                viewBox="0 0 27 31.5"
                              >
                                <g
                                  id="delete"
                                  transform="translate(-4.5 -2.25)"
                                >
                                  <path
                                    id="Path_64"
                                    data-name="Path 64"
                                    d="M13.5,13.5h2.25V27H13.5Z"
                                    fill="#9cabc4"
                                  />
                                  <path
                                    id="Path_65"
                                    data-name="Path 65"
                                    d="M20.25,13.5H22.5V27H20.25Z"
                                    fill="#9cabc4"
                                  />
                                  <path
                                    id="Path_66"
                                    data-name="Path 66"
                                    d="M4.5,6.75V9H6.75V31.5A2.25,2.25,0,0,0,9,33.75H27a2.25,2.25,0,0,0,2.25-2.25V9H31.5V6.75ZM9,31.5V9H27V31.5Z"
                                    fill="#9cabc4"
                                  />
                                  <path
                                    id="Path_67"
                                    data-name="Path 67"
                                    d="M13.5,2.25h9V4.5h-9Z"
                                    fill="#9cabc4"
                                  />
                                </g>
                              </svg>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="cart_item" v-else>
                      No item added for this category
                    </div>
                    <p
                      class="alert alert-warning"
                      v-if="is_min_default_dry_clean_applicable"
                    >
                      Default minimum price for Dry cleaning (${{
                        dry_clean_default_min
                      }}) is applied here in Sub total.
                    </p>
                  </div>
                  <!-- Tailoring -->
                  <div class="cart_row">
                    <h2>Tailoring</h2>
                    <div v-if="tailoring_products && tailoring_products.length">
                      <div
                        class="cart_item"
                        v-for="data in tailoring_products"
                        :key="data.id"
                      >
                        <ul>
                          <li>
                            <h3>{{ data.name ? data.name : "" }}</h3>
                          </li>
                          <li>
                            <button
                              type="button"
                              class="count_btn decrement"
                              @click.prevent="
                                changeQty(data.id, 'tailoring', 'descrease')
                              "
                            >
                              <i class="fi fi-rr-minus-small"></i>
                            </button>
                            <input
                              type="text"
                              class="item_count"
                              v-model="tailoring_products_quantity[data.id]"
                            />
                            <button
                              type="button"
                              class="count_btn increment"
                              @click.prevent="
                                changeQty(data.id, 'tailoring', 'increase')
                              "
                            >
                              <i class="fi fi-rr-plus-small"></i>
                            </button>
                          </li>
                          <li>
                            <strong
                              >${{
                                data.total_price
                                  ? parseFloat(data.total_price).toFixed(2)
                                  : ""
                              }}
                            </strong>
                          </li>
                          <li>
                            <button
                              type="button"
                              @click="deleteModal('tailoring', data.id)"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="27"
                                height="31.5"
                                viewBox="0 0 27 31.5"
                              >
                                <g
                                  id="delete"
                                  transform="translate(-4.5 -2.25)"
                                >
                                  <path
                                    id="Path_64"
                                    data-name="Path 64"
                                    d="M13.5,13.5h2.25V27H13.5Z"
                                    fill="#9cabc4"
                                  />
                                  <path
                                    id="Path_65"
                                    data-name="Path 65"
                                    d="M20.25,13.5H22.5V27H20.25Z"
                                    fill="#9cabc4"
                                  />
                                  <path
                                    id="Path_66"
                                    data-name="Path 66"
                                    d="M4.5,6.75V9H6.75V31.5A2.25,2.25,0,0,0,9,33.75H27a2.25,2.25,0,0,0,2.25-2.25V9H31.5V6.75ZM9,31.5V9H27V31.5Z"
                                    fill="#9cabc4"
                                  />
                                  <path
                                    id="Path_67"
                                    data-name="Path 67"
                                    d="M13.5,2.25h9V4.5h-9Z"
                                    fill="#9cabc4"
                                  />
                                </g>
                              </svg>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="cart_item" v-else>
                      No item added for this category
                    </div>
                    <p
                      class="alert alert-warning"
                      v-if="is_min_default_tailoring_applicable"
                    >
                      Default minimum price for Tailoring (${{
                        tailoring_default_min
                      }}) is applied here in sub total.
                    </p>
                  </div>

                  <!-- Client Notes -->
                  <div class="customer_notes">
                    <textarea
                      placeholder="Customer Notes..."
                      v-model="orderObj.notes"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-4">
                <div class="payment_holder">
                  <!-- <h2>Pickup & Delivery Addresses</h2> -->
                  <h2>Order Summary</h2>
                  <label
                    >Name:
                    {{
                      !!current_user
                        ? current_user.full_name
                        : "Name not available"
                    }}</label
                  >
                  <label>
                    Phone:
                    {{
                      !!current_user
                        ? current_user.phone
                        : "Phone not available"
                    }}</label
                  >
                  <div class="pick_drop_location">
                    <div class="form_group">
                      <!-- <label>Pickup Location</label> -->
                      <label>Address</label>

                      <vue-google-autocomplete
                        ref="address"
                        id="map"
                        classname="location_field"
                        placeholder="Street address, city, state"
                        v-on:placechanged="getAddressDataPickup"
                        v-on:inputChange="inputChangedAutoComplete"
                        country="us"
                        :value="accountAddress"
                      >
                      </vue-google-autocomplete>
                      <!-- pickup zip start -->
                      <!-- <transition name="fade" v-if="is_show_postal_pickup">
                        <div class="mt-8">
                          <div class="error_message" style="color: yellow">
                            We haven't find your postal code from google map
                            please enter your postal code
                          </div>
                          <div class="area_input bg-transparent">
                            <input
                              type="text"
                              name=""
                              placeholder="Postal Code"
                              v-model="postal_pickup"
                              style="padding: 10px 15px"
                              @input="checkPostal('pickup')"
                            />

                            <svg
                              v-if="is_postal_found_pickup"
                              xmlns="http://www.w3.org/2000/svg"
                              width="36"
                              height="36"
                              fill="currentColor"
                              class="bi bi-check"
                              viewBox="0 0 16 16"
                              color="#FC6D4C"
                            >
                              <path
                                d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
                              />
                            </svg>

                            <svg
                              v-if="!is_postal_found_pickup"
                              xmlns="http://www.w3.org/2000/svg"
                              width="36"
                              height="36"
                              fill="currentColor"
                              class="bi bi-x"
                              viewBox="0 0 16 16"
                              color="yellow"
                            >
                              <path
                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                              />
                            </svg>

                            
                          </div>
                        </div>
                      </transition>

                      <transition
                        name="fade"
                        v-if="is_postal_found_pickup == false"
                      >
                        <div class="error_message" style="color: yellow">
                          <strong>Sorry!</strong> we do not currently service
                          this area!
                        </div>
                      </transition> -->
                      <!-- pickup zip end -->
                      <div class="form_group mt-3">
                        <label>Apartment number</label>
                        <input
                          type="text"
                          name=""
                          placeholder="Apartment number"
                          v-model="orderObj.pickup_addr_apt"
                        />
                      </div>

                      <div class="delivery_option pick_drop_option">
                        <ul>
                          <li>
                            <div class="form-check w-100">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="pickup"
                                value="true"
                                v-model="orderObj.is_pickup_attended"
                              />
                              <label
                                class="form-check-label"
                                for="individual-delivery"
                              >
                                Attended (you will meet the driver)
                              </label>
                            </div>
                          </li>
                          <li>
                            <div class="form-check w-100">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="pickup"
                                value="false"
                                v-model="orderObj.is_pickup_attended"
                              />
                              <label
                                class="form-check-label"
                                for="combined-delivery"
                              >
                                Unattended (laundry will be left in a safe
                                location)
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <textarea
                        placeholder="Enter specific instructions and/or directions to locate your location."
                        v-if="!is_pickup_attended"
                        v-model="orderObj.pickup_attended_notes"
                      ></textarea>
                    </div>
                    <!-- <div class="form_group">
                      <label>Dropped Location</label>
                    
                      <vue-google-autocomplete
                        ref="address"
                        id="map_delivery"
                        classname="location_field"
                        placeholder="Street address, city, state"
                        v-on:placechanged="getAddressDataDelivery"
                        country="us"
                        :value="accountAddress"
                      >
                      </vue-google-autocomplete>

                      
                      <transition name="fade" v-if="is_show_postal_delivery">
                        <div class="mt-8">
                          <div class="error_message" style="color: yellow">
                            We haven't find your postal code from google map
                            please enter your postal code
                          </div>
                          <div class="area_input bg-transparent">
                            <input
                              type="text"
                              name=""
                              placeholder="Postal Code"
                              v-model="postal_delivery"
                              style="padding: 10px 15px"
                              @input="checkPostal('delivery')"
                            />

                            <svg
                              v-if="is_postal_found_delivery"
                              xmlns="http://www.w3.org/2000/svg"
                              width="36"
                              height="36"
                              fill="currentColor"
                              class="bi bi-check"
                              viewBox="0 0 16 16"
                              color="#FC6D4C"
                            >
                              <path
                                d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
                              />
                            </svg>

                            <svg
                              v-if="!is_postal_found_delivery"
                              xmlns="http://www.w3.org/2000/svg"
                              width="36"
                              height="36"
                              fill="currentColor"
                              class="bi bi-x"
                              viewBox="0 0 16 16"
                              color="yellow"
                            >
                              <path
                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                              />
                            </svg>
                           
                          </div>
                        </div>
                      </transition>

                    
                      <transition
                        name="fade"
                        v-if="is_postal_found_delivery == false"
                      >
                        <div class="error_message" style="color: yellow">
                          <strong>Sorry!</strong> we do not currently service
                          this area!
                        </div>
                      </transition>
                      
                      <div class="form_group mt-3">
                        <label>Apartment number</label>
                        <input
                          type="text"
                          name=""
                          placeholder="Apartment number"
                          v-model="orderObj.delivery_addr_apt"
                          required
                        />
                      </div>

                      <div class="delivery_option pick_drop_option">
                        <ul>
                          <li>
                            <div class="form-check w-100">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="dropped"
                                value="true"
                                v-model="orderObj.is_delivery_attended"
                              />
                              <label
                                class="form-check-label"
                                for="individual-delivery"
                              >
                                Attended (you will meet the driver)
                              </label>
                            </div>
                          </li>
                          <li>
                            <div class="form-check w-100">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="dropped"
                                value="false"
                                v-model="orderObj.is_delivery_attended"
                              />
                              <label
                                class="form-check-label"
                                for="combined-delivery"
                              >
                                Unattended (laundry will be left in a safe
                                location)
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <textarea
                        placeholder="Notes"
                        v-if="!is_delivery_attended"
                        v-model="orderObj.delivery_attended_notes"
                      ></textarea>
                    </div> -->
                  </div>
                  <hr />
                  <div class="row pt-md-5">
                    <div class="col-md-8 col-xs-8 col-sm-8">
                      <h2>Payment Info</h2>
                    </div>
                    <div class="col-md-4 col-xs-4 col-sm-4">
                      <div class="payment_logos">
                        <img
                          src="/src/assets/images/master-logo.png"
                          alt=""
                          style="width: 24px"
                        />
                        <img
                          src="/src/assets/images/visa-logo.png"
                          alt=""
                          style="width: 24px"
                        />
                        <img
                          src="/src/assets/images/discover-logo.jpg"
                          alt=""
                          style="width: 24px"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="alert alert-danger alert-dismissible"
                    v-if="status && status == 500 && stripe_error"
                  >
                    <strong>Failed!</strong> {{ stripe_error }}.
                  </div>
                  <!-- payment methods -->
                  <div class="row">
                    <label for=""
                      >Select a payment method or create a new one.</label
                    >
                    <select
                    required
                      style="
                        background-color: #2d87af;
                        border: none;
                        margin-left: 12px;
                        width: 80%;
                        margin-bottom: 16px;
                        color: white;
                      "
                      class="form-select"
                      v-model="selectedMethod"
                      @change="changePaymentMethod(selectedMethod)"
                    >
                      <option :value="-1" selected>Create New</option>
                      <option
                        v-for="data in payments_methods"
                        :key="data"
                        :value="data"
                      >
                        {{ data.card.last4 }}
                      </option>
                    </select>
                  </div>
                  <div class="card_detail">
                    <div class="form_group">
                      <label>Name on Card</label>
                      <input
                        type="text"
                        name=""
                        placeholder="John Deo"
                        v-model="orderObj.name"
                        required
                      />
                    </div>
                    <div class="form_group">
                      <label>Card Number</label>
                      <input
                        type="text"
                        name=""
                        placeholder="XXXX XXXX XXXX XXXX"
                        v-model="orderObj.card_number"
                        required
                      />
                    </div>
                    <div class="card_date_cvv">
                      <div class="form_group">
                        <label>Expiry Date</label>
                        <input
                          type="text"
                          name=""
                          maxlength="7"
                          placeholder="MM/YYYY"
                          v-model="orderObj.card_expiry"
                          @input.prevent="expiryDateSlashInsert()"
                        />
                      </div>
                      <div class="form_group">
                        <label>CVV</label>
                        <input
                          type="text"
                          name=""
                          placeholder="XXX"
                          v-model="orderObj.card_cvv"
                        />
                      </div>
                    </div>

                    <div class="form_group my_billing">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="checkbox"
                          v-model="billing_addr_checked"
                        />
                        <label class="form-check-label" for="checkbox">
                          My billing address is same as delivery address.
                        </label>
                      </div>

                      <!--<input
                        type="checkbox"
                        id="checkbox"
                        v-model="billing_addr_checked"
                      />
                      <label for="checkbox"
                        >My billing address is same as delivery address.</label
                      > -->
                    </div>
                    <!-- new added -- billing address -->
                    <div class="form_group" v-if="!billing_addr_checked">
                      <label>Billing Address</label>
                      <input
                        type="text"
                        name=""
                        placeholder="Enter your billing address"
                        v-model="orderObj.billing_address_payment"
                      />
                    </div>
                  </div>

                  <hr />

                  <h2>Cart Total</h2>
                  <div class="payment_detail">
                    <ul>
                      <li>
                        <span>Sub Total</span>
                        <span>${{ parseFloat(sub_total).toFixed(2) }}</span>
                      </li>
                      <li v-if="orderObj.is_wash_premium && sum_wash > 0">
                        <span>Same Day Delivery Fee</span>
                        <span>${{ orderObj.wash_premium_fee }}</span>
                      </li>
                      <li>
                        <span>Processing Fee</span>
                        <span>${{ service_fee }}</span>
                      </li>
                      <li>
                        <span>Delivery</span>
                        <span>Free</span>
                      </li>
                      <li>
                        <div class="form_group">
                          <label>Promo Discount</label>
                          <input
                            type="text"
                            name=""
                            v-model="promoCode"
                            placeholder="Enter promo code..."
                            style="width: 218px; padding: 10px"
                          />
                        </div>

                        <span
                          ><button
                            class="button promo_button"
                            type="submit"
                            @click.prevent="usePromoCode()"
                          >
                            Apply
                          </button></span
                        >
                      </li>
                      <li v-if="CCUserCreditAvailable > 0.0">
                        <span>Promo Credit Applied </span>
                        <span> - ${{ CCUserCreditAvailable }}</span>
                      </li>

                      <li v-if="CCUserDiscountPercentageValue > 0.0">
                        <span>Promo Discount Applied (%)</span>
                        <span>
                          - ${{
                            parseFloat(
                              this.CCUserDiscountPercentageValue
                            ).toFixed(2)
                          }}</span
                        >
                      </li>
                      <li>
                        <span>Total</span>
                        <span
                          >${{
                            grand_total > 0
                              ? parseFloat(grand_total).toFixed(2)
                              : 0.0
                          }}</span
                        >
                        <!-- Can be 0 if more Credit apply than the current basket size -->
                      </li>
                    </ul>
                  </div>
                  <div
                    class="alert alert-danger alert-dismissible"
                    v-if="serverError"
                  >
                    <strong>{{ serverError }}</strong>
                  </div>
                  <!-- <div class="checkout_btn">
                    <button
                      class="button primary_button"
                      type="submit"
                      :disabled="!is_postal_found_pickup"
                    >
                      Checkout
                    </button>
                  </div> -->
                  <div class="checkout_btn">
                    <button class="button primary_button" type="submit">
                      Checkout
                    </button>
                  </div>

                  <div class="agree_text margin_agree">
                    By clicking on "Checkout" you agree to the
                    <router-link :to="{ name: 'terms-and-conditions' }"
                      >Terms of Use</router-link
                    >
                    and
                    <router-link :to="{ name: 'privacy-policy' }"
                      >Privacy Policy</router-link
                    >
                    of dirtydrawz.com
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </main>
    <!--   Main Content End Here   -->

    <!-- delete cofirmation modal -->

    <div
      class="modal fade"
      id="deleteModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="close_modal">
              <button type="button" data-bs-dismiss="modal" aria-label="Close">
                <i class="fi fi-rr-cross-small"></i>
              </button>
            </div>
            <div class="modal_content">
              <h2>Confirmation</h2>
              <p>Are you sure want to delete this item?</p>

              <div class="modal_buttons">
                <button
                  type="button"
                  class="button secondary_button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  No
                </button>
                <button
                  type="button"
                  class="button primary_button"
                  @click.prevent="deleteItem()"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- end delete confirmation modal -->

    <!-- add product wash modal-->

    <div
      class="modal fade"
      id="washModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-body">
            <div class="close_modal">
              <button type="button" data-bs-dismiss="modal" aria-label="Close">
                <i class="fi fi-rr-cross-small"></i>
              </button>
            </div>
            <div class="modal_content">
              <h2>Wash & Fold</h2>
              <div class="my_items my_tailored">
                <div class="row">
                  <div
                    class="col-6 col-md-4 col-lg-3"
                    v-for="data in wash_clean_products"
                    :key="data"
                  >
                    <div
                      class="item_col"
                      @click.prevent="
                        cartProducts(
                          data,
                          data.quantity,
                          'wash',
                          'wash_product'
                        );
                        activate(data.id, 'wash');
                      "
                    >
                      <div class="item_img">
                        <img
                          :src="
                            data.ic
                              ? 'https://s3.us-east-2.amazonaws.com/cleancloudapp/ic/b/' +
                                data.ic
                              : '/src/assets/images/image-placeholder.png'
                          "
                          class="img-fluid"
                          alt=""
                        />
                      </div>
                      <div class="item_col_content">
                        <span>
                          $
                          {{
                            wash_product_weight[data.id]
                              ? parseFloat(
                                  wash_product_weight[data.id] * data.price
                                ).toFixed(2)
                              : data.price
                          }}</span
                        >
                        <ul>
                          <li>
                            <input
                              type="text"
                              class="item_count"
                              v-model="wash_product_weight[data.id]"
                            />
                            {{ data.name ? data.name : "" }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal_buttons">
                <button
                  type="button"
                  class="button secondary_button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- end wash add modal -->
  </div>
</template>
<script>
import productsApis from "../Apis/products";
import usersApis from "../Apis/users";
import VueGoogleAutocomplete from "vue-google-autocomplete";

import {
  getCurrentUserCleanId,
  getCurrentUserId,
  removeOrderLocalStorage,
} from "../utils/auth";
import webSettingsApis from "../Apis/webSettings";
import moment from "moment";
export default {
  components: {
    VueGoogleAutocomplete,
  },
  data() {
    return {
      payments_methods: null,
      deleted_id: null,

      serverError: "",
      credit_used: 0.0,
      promoCode: null,
      CCUserCreditAvailable: 0.0,
      CCUserDiscountPercentage: 0.0,
      CCUserDiscountPercentageValue: 0.0,
      totalPromoDiscountApplied: 0.0,

      usePromoCodeObj: {
        customerId: getCurrentUserCleanId(),
        promoCode: null,
      },
      billing_addr_checked: true,

      accountAddress: !!localStorage.getItem("current_user")
        ? JSON.parse(localStorage.getItem("current_user")).address
        : "",
      accountZipCode: !!localStorage.getItem("current_user")
        ? JSON.parse(localStorage.getItem("current_user")).zip_code
        : "",
      loader: true,
      wash_clean_products: [],
      delete_obj: {},
      current_user: !!localStorage.getItem("current_user")
        ? JSON.parse(localStorage.getItem("current_user"))
        : null,
      orderObj: {
        // name: "test", //name: null,
        name: null,
        // card_number: "4242424242424242", //card_number: null,
        card_number: null,
        user_id: getCurrentUserId(),
        customerID: getCurrentUserCleanId(),
        is_pickup_attended: true,
        pickup_attended_notes: null,
        is_delivery_attended: true,
        delivery_attended_notes: null,
        // card_expiry: "12/22", //card_expiry: null,
        card_expiry: null,
        // card_cvv: "123", //card_cvv: null,
        card_cvv: null,
        pickup_location: !!localStorage.getItem("current_user")
          ? JSON.parse(localStorage.getItem("current_user")).address
          : "",
        delivery_location: null,
        pickup_addr_apt: !!localStorage.getItem("current_user")
          ? JSON.parse(localStorage.getItem("current_user")).apt_num
          : "", // pickup_addr_apt: null,
        delivery_addr_apt: !!localStorage.getItem("current_user")
          ? JSON.parse(localStorage.getItem("current_user")).apt_num
          : "", //delivery_addr_apt: null,
        grand_total: 0,
        notes: null,
        pickup_date: null,
        pickupStart: null,
        pickup_start_time: null,
        pickupEnd: null,
        delivery_date: null,
        deliveryStart: null,
        delivery_start_time: null,
        deliveryEnd: null,
        pickup_time_slot: null,
        delivery_time_slot: null,
        is_individual: JSON.parse(localStorage.getItem("is_individual")),
        highest_delivery_type: JSON.parse(
          localStorage.getItem("highest_delivery_days")
        ),

        is_wash_premium: 0,
        wash_premium_fee: 0,

        wash_grand_total: 0,
        dry_clean_grand_total: 0,
        tailoring_grand_total: 0,

        is_min_default_dry_clean_applicable: false,
        is_min_default_tailoring_applicable: false,
        dry_clean_default_min: 0,
        tailoring_default_min: 0,

        pickups: {
          wash: {},
          dry_clean: {},
          tailoring: {},
          combined: {},
        },
        delivery: {
          wash: {},
          dry_clean: {},
          tailoring: {},
          combined: {},
        },
        credit_used: 0.0,
        should_create_new_stripe: true,
      },
      dry_clean_products: null,
      dry_clean_products_quantity: {},
      tailoring_products: null,
      tailoring_products_quantity: {},
      wash_product_weight: {},
      wash_products: null,
      sum_wash: 0,
      sum_dry_clean: 0,
      sum_tailoring: 0,
      sub_total: 0,
      service_fee: parseFloat(
        JSON.parse(localStorage.getItem("system_service_fee"))
      ),
      grand_total: 0,

      is_pickup_attended: true,
      is_delivery_attended: true,

      stripe_error: null,
      status: null,

      is_show_postal_pickup: false,

      is_postal_found_pickup: false,

      is_show_postal_delivery: false,
      is_postal_found_delivery: false,
      postal_pickup: !!localStorage.getItem("current_user")
        ? JSON.parse(localStorage.getItem("current_user")).zip_code
        : "",

      postal_delivery: !!localStorage.getItem("current_user")
        ? JSON.parse(localStorage.getItem("current_user")).zip_code
        : "",

      given_areas: null,
    };
  },
  watch: {
    "$store.state.cart_products": function (products) {
      this.setData(products);
    },
    "orderObj.is_pickup_attended": function (val) {
      console.log("trigger", typeof val, val);
      if (val == "true") {
        this.is_pickup_attended = true;
      } else {
        this.is_pickup_attended = false;
      }
    },
    "orderObj.is_delivery_attended": function (val) {
      console.log("trigger", typeof val, val);
      if (val == "true") {
        this.is_delivery_attended = true;
      } else {
        this.is_delivery_attended = false;
      }
    },
    sum_wash: function (val) {
      let wash_price = this.sum_wash;
      // if (this.orderObj.is_wash_premium) {
      //   wash_price = parseFloat(this.orderObj.wash_premium_fee) + wash_price;
      // }
      this.sub_total = this.sum_dry_clean + wash_price + this.sum_tailoring;

      console.log("sum_wash-sub_tatal", this.sub_total);
    },
    sum_dry_clean: function (val) {
      let wash_price = this.sum_wash;
      // if (this.orderObj.is_wash_premium) {
      //   wash_price = parseFloat(this.orderObj.wash_premium_fee) + wash_price;
      // }
      if (this.is_min_default_dry_clean_applicable) {
        // If Min Tailoring is appliacble AND larger then the tailor_cart products , it will not charge the current items price and instead it will charge the default price
        let defaultPrice = localStorage.getItem("min_dry_clean_price");

        this.sum_dry_clean =
          defaultPrice > this.sum_dry_clean ? defaultPrice : this.sum_dry_clean;

        this.sub_total =
          (defaultPrice > this.sum_dry_clean
            ? defaultPrice
            : this.sum_dry_clean) +
          wash_price +
          this.sum_tailoring;
      } else {
        this.sub_total = this.sum_dry_clean + wash_price + this.sum_tailoring;
      }

      console.log("sum_dry-sub_tatal", this.sub_total);
    },
    sum_tailoring: function (val) {
      let wash_price = this.sum_wash;
      // if (this.orderObj.is_wash_premium) {
      //   wash_price = parseFloat(this.orderObj.wash_premium_fee) + wash_price;
      // }

      if (this.is_min_default_tailoring_applicable) {
        // If Min Tailoring is appliacble AND larger then the tailor_cart products , it will not charge the current items price and instead it will charge the default price
        let defaultPrice = localStorage.getItem("min_tailoring_price");

        this.sum_tailoring =
          defaultPrice > this.sum_tailoring ? defaultPrice : this.sum_tailoring;

        this.sub_total =
          this.sum_dry_clean +
          wash_price +
          (defaultPrice > this.sum_tailoring
            ? defaultPrice
            : this.sum_tailoring);
      } else {
        this.sub_total = this.sum_dry_clean + wash_price + this.sum_tailoring;
      }
      console.log("sum_tail-sub_tatal", this.sub_total);
    },
    sub_total: function (val) {
      let total =
        this.sub_total +
        parseFloat(this.service_fee) +
        (this.sum_wash > 0 ? parseFloat(this.orderObj.wash_premium_fee) : 0.0); // wash same day primuim should only be applied if wash products are present

      this.grand_total = total;

      // updating grand total
      if (this.grand_total >= this.CCUserCreditAvailable) {
        this.grand_total = this.grand_total - this.CCUserCreditAvailable;
        this.totalPromoDiscountApplied = this.CCUserCreditAvailable;

        this.credit_used = this.CCUserCreditAvailable;
      } else {
        this.credit_used = this.grand_total;
        this.totalPromoDiscountApplied = this.grand_total;
        this.grand_total = 0.0;
      }

      this.CCUserDiscountPercentageValue =
        (total * this.CCUserDiscountPercentage) / 100;
      this.grand_total = this.grand_total - this.CCUserDiscountPercentageValue;
      this.totalPromoDiscountApplied += this.CCUserDiscountPercentageValue;
    },
  },
  methods: {
    checkPostal(type) {
      console.log("checkpostel");
      if (type == "pickup") {
        const index = this.given_areas.findIndex(
          (it) => it == this.postal_pickup
        );
        if (index === -1) {
          // this.is_postal_found_pickup = false;// IMP :: Temp comment :: Client wants to show all adresses
          this.is_postal_found_pickup = true;
        } else {
          this.is_postal_found_pickup = true;
        }
      }

      if (type == "delivery") {
        const index = this.given_areas.findIndex(
          (it) => it == this.postal_delivery
        );
        if (index === -1) {
          this.is_postal_found_delivery = false;
        } else {
          this.is_postal_found_delivery = true;
        }
      }
    },

    async addProductModal(type) {
      if (type == "wash") {
        var myModal = new bootstrap.Modal(document.getElementById("washModal"));
        myModal.show();
      }
    },
    /** G maps addresses pickup, delivery */
    inputChangedAutoComplete: function (obj) {
      console.log("input change auto", obj.newVal);
      this.orderObj.address = obj.newVal; // getting only text (user input).
    },

    getAddressDataPickup: function (addressData, placeResultData, id) {
      this.postal_pickup = "";
      // this.is_postal_found_pickup = false;// IMP :: Temp comment :: Client wants to show all adresses
      this.is_postal_found_pickup = true;

      console.log("addressData", addressData);
      console.log("placeResultData", placeResultData);

      //----------------- Z

      this.orderObj.pickup_location =
        placeResultData && placeResultData.formatted_address
          ? placeResultData.formatted_address
          : this.accountAddress; // if nothing set in pickup, set default account address

      /** Checking if postal code is valid or not */
      if (addressData && addressData.postal_code) {
        this.is_show_postal_pickup = false;
        const index = this.given_areas.findIndex(
          (it) => it == addressData.postal_code
        );
        if (index === -1) {
          /**postal code not exist in array */
          // this.is_postal_found_pickup = false;// IMP :: Temp comment :: Client wants to show all adresses
          this.is_postal_found_pickup = true;
        } else {
          /**postal code exist in array */
          this.is_postal_found_pickup = true;
        }
      } else {
        this.is_show_postal_pickup = true;
      }
    },

    getAddressDataDelivery: function (addressData, placeResultData, id) {
      this.postal_delivery = "";
      this.is_postal_found_delivery = false;

      this.orderObj.delivery_location =
        placeResultData && placeResultData.formatted_address
          ? placeResultData.formatted_address
          : this.accountAddress; // if nothing set in delivery address, set default account address

      // checking if WE serve in this postal code or not
      if (addressData && addressData.postal_code) {
        this.is_show_postal_delivery = false;
        const index = this.given_areas.findIndex(
          (it) => it == addressData.postal_code
        );
        if (index === -1) {
          /**postal code not exist in array */
          this.is_postal_found_delivery = false;
        } else {
          /**postal code exist in array */
          this.is_postal_found_delivery = true;
        }
      } else {
        this.is_show_postal_delivery = true;
      }
    },

    /** CTA for get clean cloud products from backend*/
    async getProducts() {
      const data = (await productsApis.getCleanCloudProducts()).data;
      console.log("getProducts data", data);
      if (data && data.Products) {
        // this.clean_products = data.Products;
        data["Products"].forEach((element) => {
          if (
            element.section &&
            element.section == process.env.WASH_CLEAN_KEY
          ) {
            element.quantity = 1;
            this.wash_clean_products.push(element);
          }
        });
      }
    },

    async usePromoCode() {
      this.serverError = "";
      this.usePromoCodeObj.promoCode = this.promoCode;
      productsApis
        .usePromoCode(this.usePromoCodeObj)
        .then((response) => {
          // this.CCUserDiscountPercentage = response.data.discountPercent
          //   ? response.data.discountPercent
          //   : 0.0;

          if (response.data.discountPercent) {
            this.CCUserDiscountPercentage = response.data.discountPercent; //updating discountpercent (beaware -> discountpercent vs discountPercentage)
          }

          this.CCUserDiscountPercentageValue =
            (this.grand_total * this.CCUserDiscountPercentage) / 100;
          this.grand_total =
            this.grand_total - this.CCUserDiscountPercentageValue;
          this.totalPromoDiscountApplied = this.CCUserDiscountPercentageValue;

          var dontApplyPercentageAgain = true;

          this.applyExistingCredit(dontApplyPercentageAgain);
        })
        .catch((error) => {
          console.log(error);
          this.serverError = error.response.data.error
            ? error.response.data.error
            : "";
        });
    },
    isActive(id) {
      if (this.wash_product_weight[id]) {
        // console.log("this.wash_product_weight[id]",this.wash_product_weight[id]);
        return true;
      }
    },
    activate(id, type) {
      // setting quantity of product with its id
      if (!this.wash_product_weight[id]) {
        /** because min. weight for wash and fold is 15 lb */
        // if (type == "wash" && id == "10001") {
        if (type == "wash" && id == "288") {
          this.wash_product_weight[id] = 15;
        } else {
          this.wash_product_weight[id] = 1;
        }
      }
    },
    /** CTA for adding product into cart */
    cartProducts(product, qty, type, call_from) {
      console.log("product in CartProduct", product);
      console.log("quantity passed", qty);

      product.type = type;
      product.quantity = this.wash_product_weight[product.id]
        ? this.wash_product_weight[product.id]
        : qty;

      console.log("product of wash n fold", product);

      product.total_price = product.price * product.quantity;

      if (call_from == "wash_product") {
        const index = this.wash_products.findIndex(
          (it) => it.id === product.id
        );
        if (index === -1) {
          this.wash_products.push(product);
        }
      }
      this.calculateSum();
      this.$store.dispatch("setCart", product);
    },
    changeWash(id) {
      if (this.wash_product_weight[id] >= 15) {
        const index = this.wash_products.findIndex((it) => it.id == id);
        const objectVal = this.wash_products.find((it) => it.id == id);
        objectVal.quantity = this.wash_product_weight[id];
        objectVal.total_price = objectVal.quantity * objectVal.price;
        this.calculateSum();
      } else {
        const index = this.wash_products.findIndex((it) => it.id == id);
        const objectVal = this.wash_products.find((it) => it.id == id);
        objectVal.quantity = 15;
        objectVal.total_price = objectVal.quantity * objectVal.price;
        this.calculateSum();
      }
    },
    /** CTA for changing qty of product */
    changeQty(id, type, action_type) {
      if (type == "wash") {
        const index = this.wash_products.findIndex((it) => it.id == id);
        const objectVal = this.wash_products.find((it) => it.id == id);
        var currentVal = this.wash_product_weight[id];
        if (action_type == "descrease" && currentVal > 1) {
          currentVal--;
          this.wash_product_weight[id] = currentVal;
          objectVal.quantity = currentVal;
          objectVal.total_price = currentVal * objectVal.price;
        } else if (action_type == "increase") {
          currentVal++;
          this.wash_product_weight[id] = currentVal;
          objectVal.quantity = currentVal;
          objectVal.total_price = currentVal * objectVal.price;
        }

        this.wash_products[index] = objectVal;
        this.$store.dispatch("setCart", objectVal);
      } else if (type == "tailoring") {
        const index = this.tailoring_products.findIndex((it) => it.id == id);
        const objectVal = this.tailoring_products.find((it) => it.id == id);
        var currentVal = this.tailoring_products_quantity[id];
        if (action_type == "descrease" && currentVal > 1) {
          currentVal--;
          this.tailoring_products_quantity[id] = currentVal;
          objectVal.quantity = currentVal;
          objectVal.total_price = currentVal * objectVal.price;
        } else if (action_type == "increase") {
          currentVal++;
          this.tailoring_products_quantity[id] = currentVal;
          objectVal.quantity = currentVal;
          objectVal.total_price = currentVal * objectVal.price;
        }

        // Real time update if default min price is applied or not.

        // objectVal.total_price > 0 &&
        // objectVal.total_price > this.tailoring_default_min
        //   ? (this.is_min_default_tailoring_applicable = false)
        //   : (this.is_min_default_tailoring_applicable = true);

        this.tailoring_products[index] = objectVal;
        this.$store.dispatch("setCart", objectVal);
        this.$forceUpdate();
        this.calculateSum();

        this.setMinTailoringPriceIfApplicable();
      } else if (type == "dry_clean") {
        const index = this.dry_clean_products.findIndex((it) => it.id == id);
        const objectVal = this.dry_clean_products.find((it) => it.id == id);
        var currentVal = this.dry_clean_products_quantity[id];
        if (action_type == "descrease" && currentVal > 1) {
          currentVal--;
          this.dry_clean_products_quantity[id] = currentVal;
          objectVal.quantity = currentVal;
          objectVal.total_price = currentVal * objectVal.price;
        } else if (action_type == "increase") {
          currentVal++;
          this.dry_clean_products_quantity[id] = currentVal;
          objectVal.quantity = currentVal;
          objectVal.total_price = currentVal * objectVal.price;
        }
        // Real time update if default min price is applied or not.
        // objectVal.total_price > 0 &&
        // objectVal.total_price > this.dry_clean_default_min
        //   ? (this.is_min_default_dry_clean_applicable = false)
        //   : (this.is_min_default_dry_clean_applicable = true);

        this.$store.dispatch("setCart", objectVal);
        this.dry_clean_products[index] = objectVal;

        this.$forceUpdate();
        this.calculateSum();
        this.setMinDrycleanPriceIfApplicable();
      }

      this.$forceUpdate();
      this.calculateSum();
    },

    /** CTA for creating order on server */
    async formSbmit() {
      this.loader = true;
      this.orderObj.wash_products = this.wash_products;
      this.orderObj.dry_clean_products = this.dry_clean_products;
      this.orderObj.tailoring_products = this.tailoring_products;
      this.orderObj.grand_total = this.grand_total;
      this.orderObj.credit_used = this.credit_used;

      /**sending them as they required for individual delivery */
      let wash_price = this.sum_wash;
      if (this.orderObj.is_wash_premium) {
        wash_price =
          (this.sum_wash > 0 ? this.orderObj.wash_premium_fee : 0.0) +
          wash_price; // if wash products are deleted later on in cart, wash primium shouldn't be applied
      }

      var wash_grand =
        wash_price +
        (this.orderObj.is_individual && this.sum_wash > 0
          ? this.service_fee
          : 0.0); // if order is individual, that means wash_grand would be considered in backend. So, setting service fee in wash grand

      if (wash_grand >= this.totalPromoDiscountApplied) {
        wash_grand = wash_grand - this.totalPromoDiscountApplied;
        this.totalPromoDiscountApplied = 0.0;
      } else {
        this.totalPromoDiscountApplied =
          this.totalPromoDiscountApplied - wash_grand;
        wash_grand = 0.0;
      }

      this.orderObj.wash_grand_total = wash_grand;

      var dry_clean_grand =
        this.sum_dry_clean +
        (this.orderObj.is_individual && this.sum_wash == 0
          ? this.service_fee
          : 0.0); // if order is individual (separate), and wash_products are not added, only then add service_fee in dry_clean grand

      if (dry_clean_grand >= this.totalPromoDiscountApplied) {
        dry_clean_grand = dry_clean_grand - this.totalPromoDiscountApplied;
        this.totalPromoDiscountApplied = 0.0;
      } else {
        this.totalPromoDiscountApplied =
          this.totalPromoDiscountApplied - dry_clean_grand;
        dry_clean_grand = 0.0;
      }

      this.orderObj.dry_clean_grand_total = dry_clean_grand;

      var tailoring_grand =
        this.sum_tailoring +
        (this.orderObj.is_individual &&
        this.sum_wash == 0 &&
        this.sum_dry_clean == 0
          ? this.service_fee
          : 0.0);

      if (tailoring_grand >= this.totalPromoDiscountApplied) {
        tailoring_grand = tailoring_grand - this.totalPromoDiscountApplied;
        this.totalPromoDiscountApplied = 0.0;
      } else {
        this.totalPromoDiscountApplied =
          this.totalPromoDiscountApplied - tailoring_grand;
        tailoring_grand = 0.0;
      }

      this.orderObj.tailoring_grand_total = tailoring_grand;
      console.log("orderObj", this.orderObj);
      // this.loader = false;
      // return;
      usersApis
        .createOrder(this.orderObj)
        .then((response) => {
          console.log(response);
          if (response.status == 200 || response.status == 204) {
            removeOrderLocalStorage();
            this.$store.dispatch("removeAllWash", []);
            this.$store.dispatch("removeAllDry", []);
            this.$store.dispatch("removeAllTailoring", []);
            this.$router.push({
              name: "my-orders",
              params: { order_created_success: true },
            });
          } else {
            console.log(response.error);
            this.status =
              "Something Went Wrong. Please try again or contact support.";
          }
        })
        .catch((error) => {
          this.loader = false;
          console.log(error.response.data.error);
          this.serverError = error.response.data.error
            ? error.response.data.error
            : "";
          this.status =
            error.response && error.response.status
              ? error.response.status
              : "";

          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.stripe_error = error.response.data.message;
          }
        })
        .then(() => {
          this.loader = false;
        });
      //  if(data && (data.status==200 || data.status==204)){
      //       removeOrderLocalStorage();
      //       this.$router.push({ name: "my-orders" });
      //  }
    },
    /*opening modal for confirmation*/

    deleteModal(type, id) {
      this.delete_obj = { type: type, id: id };

      var myModal = new bootstrap.Modal(document.getElementById("deleteModal"));
      myModal.show();
    },

    /*sending vuex to remove as well as from localstorage*/
    async deleteItem() {
      this.loader = true;

      await this.$store.dispatch("removeItem", this.delete_obj);
      await this.getLocal();

      this.$forceUpdate();
      this.calculateSum();

      this.sum_wash;
      this.sum_dry_clean;
      this.sum_tailoring;

      this.setMinDrycleanPriceIfApplicable();
      this.setMinTailoringPriceIfApplicable();

      var myModal = new bootstrap.Modal(document.getElementById("deleteModal"));
      myModal.hide();
      document.getElementById("deleteModal").style.display = "none";
      // $("#deleteModal").modal("hide");
      // $("#deleteModal").modal("dispose");
      $("body").removeClass("modal-open");
      $("body").removeClass("modal-backdrop");
      $(".modal-backdrop").remove();
      $(".fade").removeClass("show");
      $("body").css("padding-right", "0px");

      // setTimeout(() => {
      //   this.loader = false;
      // }, 1000);
      this.loader = false;
    },

    /*on create get data from vuex and set it in localstorage*/
    setData(products) {
      if (products.dry_clean_products && products.dry_clean_products.length) {
        this.dry_clean_products = products.dry_clean_products;
      }
      if (products.tailoring_products && products.tailoring_products.length) {
        this.tailoring_products = products.tailoring_products;
      }
      if (products.wash_products && products.wash_products.length) {
        this.wash_products = products.wash_products;
        this.setWashPrice();
      }

      this.calculateSum();
    },
    /* if data is not getting from vuex then get it from local stroage */
    getLocal() {
      if (
        !this.wash_products ||
        (!this.wash_products.length && localStorage.getItem("wash_products"))
      ) {
        this.wash_products = JSON.parse(localStorage.getItem("wash_products"));
        this.setWashPrice();
        this.$store.dispatch("setALLWASH", this.wash_products);
      }
      if (
        !this.tailoring_products ||
        (!this.tailoring_products.length &&
          localStorage.getItem("tailoring_products"))
      ) {
        this.tailoring_products = JSON.parse(
          localStorage.getItem("tailoring_products")
        );
        this.$store.dispatch("setALLTAILOR", this.tailoring_products);
      }
      if (
        !this.dry_clean_products ||
        (!this.dry_clean_products.length &&
          localStorage.getItem("dry_clean_products"))
      ) {
        this.dry_clean_products = JSON.parse(
          localStorage.getItem("dry_clean_products")
        );

        this.$store.dispatch("setALLDRY", this.dry_clean_products);
      }

      this.calculateSum();
    },

    /* calculate sum on each case if its from localstorage or from vuex */
    calculateSum() {
      this.sum_wash = 0;
      this.sum_dry_clean = 0;
      this.sum_tailoring = 0;

      //  let wash_price = this.sum_wash;
      // if(this.orderObj.is_wash_premium){
      //   wash_price = parseFloat(this.orderObj.wash_premium_fee) + wash_price;
      // }

      if (this.wash_products && this.wash_products.length) {
        this.wash_products.forEach((element) => {
          this.sum_wash += !!element.total_price ? element.total_price : 0.0;
        });
      }
      if (this.dry_clean_products && this.dry_clean_products.length) {
        this.dry_clean_products.forEach((element) => {
          this.sum_dry_clean += !!element.total_price
            ? element.total_price
            : 0.0;
        });
      }
      if (this.tailoring_products && this.tailoring_products.length) {
        this.tailoring_products.forEach((element) => {
          this.sum_tailoring += !!element.total_price
            ? element.total_price
            : 0.0;
        });
      }
    },
    setWashPrice() {
      if (this.wash_products) {
        this.wash_products.forEach((element) => {
          // if (element.id == 10001) {
          if (element.id == 288) {
            // default wash item && it's min 15 pound weight (from web settings)
            element.quantity = 15;
            element.total_price = element.quantity * element.price;
          }
        });
      }
    },
    setMinDrycleanPriceIfApplicable() {
      console.log("sum_dryclean", this.sum_dry_clean);
      // IF wash min is already applied, no need to set Min Dry Clean
      var isMinWashExists = this.wash_products.filter(
        // (wash) => wash.id == 10001
        (wash) => wash.id == 288
      );

      console.log("Min wash exists", isMinWashExists.length);
      if (
        isMinWashExists.length == 0 &&
        this.dry_clean_products &&
        this.dry_clean_products.length > 0 &&
        this.sum_dry_clean < this.dry_clean_default_min
      ) {
        // If Min for Wash is not added, it will add min of Dry clean as per logic
        this.is_min_default_dry_clean_applicable = true;

        // If Min Tailoring is appliacble AND larger then the tailor_cart products , it will not charge the current items price and instead it will charge the default price
        let defaultPrice = parseFloat(
          localStorage.getItem("min_dry_clean_price")
        );

        this.sum_dry_clean =
          defaultPrice > this.sum_dry_clean ? defaultPrice : this.sum_dry_clean;

        this.sub_total =
          (defaultPrice > this.sum_dry_clean
            ? defaultPrice
            : this.sum_dry_clean) +
          this.wash_price +
          this.sum_tailoring;
      } else {
        this.is_min_default_dry_clean_applicable = false;
      }
    },
    setMinTailoringPriceIfApplicable() {
      console.log("sum_tailoring", this.sum_tailoring);
      // IF wash min is already applied, no need to set Min Dry Clean
      var isMinWashExists = this.wash_products.filter(
        // (wash) => wash.id == 10001
        (wash) => wash.id == 288
      );

      if (
        isMinWashExists.length == 0 &&
        this.dry_clean_products.length == 0 &&
        this.tailoring_products.length > 0 &&
        this.sum_tailoring < this.tailoring_default_min
        // !this.is_min_default_dry_clean_applicable
      ) {
        // If Min for Wash AND Dry clean is not added, it will add min for Tailoring as per logic
        this.is_min_default_tailoring_applicable = true;

        // If Min Tailoring is appliacble AND larger then the tailor_cart products , it will not charge the current items price and instead it will charge the default price
        let defaultPrice = parseFloat(
          localStorage.getItem("min_tailoring_price")
        );

        this.sum_tailoring =
          defaultPrice > this.sum_tailoring ? defaultPrice : this.sum_tailoring;

        this.sub_total =
          this.sum_dry_clean +
          this.sum_wash +
          (defaultPrice > this.sum_tailoring
            ? defaultPrice
            : this.sum_tailoring);
      } else {
        this.is_min_default_tailoring_applicable = false;
      }
    },

    settingQuantiy() {
      if (this.wash_products) {
        this.wash_products.forEach((element) => {
          // if (element.id == "10001") {
          if (element.id == "288") {
            this.wash_product_weight[element.id] = 15;
          } else {
            this.wash_product_weight[element.id] = element.quantity;
          }
        });
      }
      if (this.dry_clean_products) {
        this.dry_clean_products.forEach((element) => {
          this.dry_clean_products_quantity[element.id] = element.quantity;
        });
      }
      if (this.tailoring_products) {
        this.tailoring_products.forEach((element) => {
          this.tailoring_products_quantity[element.id] = element.quantity;
        });
      }
    },

    getTiming() {
      // if (localStorage.getItem("pickup_date")) {
      //   const data = JSON.parse(localStorage.getItem("pickup_date"));
      //   this.orderObj.pickup_date = data.formated_date;
      // }
      // if (localStorage.getItem("delivery_date")) {
      //   const data = JSON.parse(localStorage.getItem("delivery_date"));
      //   this.orderObj.delivery_date = data.formated_date;
      // }

      /** set timing for each */

      if (
        localStorage.getItem("pickup_timing_wash") &&
        localStorage.getItem("pickup_timing_wash") != "undefined"
      ) {
        const data = JSON.parse(localStorage.getItem("pickup_timing_wash"));
        this.orderObj.pickups["wash"].start_time = data.start_time;
        this.orderObj.pickups["wash"].start_time_split =
          data.start_time_split + data.start_time_type;
        this.orderObj.pickups["wash"].end_time =
          data.end_time_split + data.end_time_type;
      }

      if (
        localStorage.getItem("delivery_timing_wash") &&
        localStorage.getItem("delivery_timing_wash") != "undefined"
      ) {
        // set time for same day delivery
        if (localStorage.getItem("wash_same_day_delivery") == "true") {
          this.orderObj.delivery["wash"].start_time = "19:00:00";
          this.orderObj.delivery["wash"].start_time_split = "7pm";
          this.orderObj.delivery["wash"].end_time = "9pm";
        } else {
          const data = JSON.parse(localStorage.getItem("delivery_timing_wash"));
          this.orderObj.delivery["wash"].start_time = data.start_time;
          this.orderObj.delivery["wash"].start_time_split =
            data.start_time_split + data.start_time_type;
          this.orderObj.delivery["wash"].end_time =
            data.end_time_split + data.end_time_type;
        }
      }

      if (
        localStorage.getItem("pickup_timing_dry_clean") &&
        localStorage.getItem("pickup_timing_dry_clean") != "undefined"
      ) {
        const data = JSON.parse(
          localStorage.getItem("pickup_timing_dry_clean")
        );
        this.orderObj.pickups["dry_clean"].start_time = data.start_time;
        this.orderObj.pickups["dry_clean"].start_time_split =
          data.start_time_split + data.start_time_type;
        this.orderObj.pickups["dry_clean"].end_time =
          data.end_time_split + data.end_time_type;
      }
      if (
        localStorage.getItem("delivery_timing_dry_clean") &&
        localStorage.getItem("delivery_timing_dry_clean") != "undefined"
      ) {
        const data = JSON.parse(
          localStorage.getItem("delivery_timing_dry_clean")
        );
        this.orderObj.delivery["dry_clean"].start_time = data.start_time;
        this.orderObj.delivery["dry_clean"].start_time_split =
          data.start_time_split + data.start_time_type;
        this.orderObj.delivery["dry_clean"].end_time =
          data.end_time_split + data.end_time_type;
      }

      if (
        localStorage.getItem("pickup_timing_tailoring") &&
        localStorage.getItem("pickup_timing_tailoring") != "undefined"
      ) {
        const data = JSON.parse(
          localStorage.getItem("pickup_timing_tailoring")
        );
        this.orderObj.pickups["tailoring"].start_time = data.start_time;
        this.orderObj.pickups["tailoring"].start_time_split =
          data.start_time_split + data.start_time_type;
        this.orderObj.pickups["tailoring"].end_time =
          data.end_time_split + data.end_time_type;
      }
      if (
        localStorage.getItem("delivery_timing_tailoring") &&
        localStorage.getItem("delivery_timing_tailoring") != "undefined"
      ) {
        const data = JSON.parse(
          localStorage.getItem("delivery_timing_tailoring")
        );
        this.orderObj.delivery["tailoring"].start_time = data.start_time;
        this.orderObj.delivery["tailoring"].start_time_split =
          data.start_time_split + data.start_time_type;
        this.orderObj.delivery["tailoring"].end_time =
          data.end_time_split + data.end_time_type;
      }

      if (
        localStorage.getItem("pickup_timing_combined") &&
        localStorage.getItem("pickup_timing_combined") != "undefined"
      ) {
        const data = JSON.parse(localStorage.getItem("pickup_timing_combined"));
        this.orderObj.pickups["combined"].start_time = data.start_time;
        this.orderObj.pickups["combined"].start_time_split =
          data.start_time_split + data.start_time_type;
        this.orderObj.pickups["combined"].end_time =
          data.end_time_split + data.end_time_type;
      }
      if (
        localStorage.getItem("delivery_timing_combined") &&
        localStorage.getItem("delivery_timing_combined") != "undefined"
      ) {
        const data = JSON.parse(
          localStorage.getItem("delivery_timing_combined")
        );
        this.orderObj.delivery["combined"].start_time = data.start_time;
        this.orderObj.delivery["combined"].start_time_split =
          data.start_time_split + data.start_time_type;
        this.orderObj.delivery["combined"].end_time =
          data.end_time_split + data.end_time_type;
      }

      /** set date for each */
      if (
        localStorage.getItem("pickup_date_wash") &&
        localStorage.getItem("pickup_date_wash") != "undefined"
      ) {
        this.orderObj.pickups["wash"].pickup_date = JSON.parse(
          localStorage.getItem("pickup_date_wash")
        );
      }
      if (
        localStorage.getItem("delivery_date_wash") &&
        localStorage.getItem("delivery_date_wash") != "undefined"
      ) {
        // set time for same day delivery
        if (this.orderObj.is_wash_premium) {
          console.log("same day delivery - Cart.vue - gettimings()");
          this.orderObj.delivery["wash"].delivery_date = new Date().format(
            "YYYY-MM-DD"
          );
        } else {
          this.orderObj.delivery["wash"].delivery_date = JSON.parse(
            localStorage.getItem("delivery_date_wash")
          );
        }
      }

      if (
        localStorage.getItem("pickup_date_dry_clean") &&
        localStorage.getItem("pickup_date_dry_clean") != "undefined"
      ) {
        this.orderObj.pickups["dry_clean"].pickup_date = JSON.parse(
          localStorage.getItem("pickup_date_dry_clean")
        );
      }
      if (
        localStorage.getItem("delivery_date_dry_clean") &&
        localStorage.getItem("delivery_date_dry_clean") != "undefined"
      ) {
        this.orderObj.delivery["dry_clean"].delivery_date = JSON.parse(
          localStorage.getItem("delivery_date_dry_clean")
        );
      }

      if (
        localStorage.getItem("pickup_date_tailoring") &&
        localStorage.getItem("pickup_date_tailoring") != "undefined"
      ) {
        this.orderObj.pickups["tailoring"].pickup_date = JSON.parse(
          localStorage.getItem("pickup_date_tailoring")
        );
      }
      if (
        localStorage.getItem("delivery_date_tailoring") &&
        localStorage.getItem("delivery_date_tailoring") != "undefined"
      ) {
        this.orderObj.delivery["tailoring"].delivery_date = JSON.parse(
          localStorage.getItem("delivery_date_tailoring")
        );
      }

      if (
        localStorage.getItem("pickup_date_combined") &&
        localStorage.getItem("pickup_date_combined") != "undefined"
      ) {
        this.orderObj.pickups["combined"].pickup_date = JSON.parse(
          localStorage.getItem("pickup_date_combined")
        );
      }
      if (
        localStorage.getItem("delivery_date_combined") &&
        localStorage.getItem("delivery_date_combined") != "undefined"
      ) {
        this.orderObj.delivery["combined"].delivery_date = JSON.parse(
          localStorage.getItem("delivery_date_combined")
        );
      }

      // if (localStorage.getItem("delivery_timing")) {
      //   const data = JSON.parse(localStorage.getItem("delivery_timing"));
      //   this.orderObj.delivery_start_time = data.start_time;
      //   this.orderObj.deliveryStart =
      //     data.start_time_split + data.start_time_type;
      //   this.orderObj.deliveryEnd = data.end_time_split + data.end_time_type;
      // }
    },

    backStep() {
      this.$router.go(-1);
      // this.$parent.backStep();
    },

    expiryDateSlashInsert() {
      console.log("EXPIRY------------");
      if (
        this.orderObj.card_expiry.length > 2 &&
        !this.orderObj.card_expiry.includes("/")
      ) {
        this.orderObj.card_expiry = [
          this.orderObj.card_expiry.slice(0, 2),
          "/",
          this.orderObj.card_expiry.slice(2),
        ].join("");
      }
    },

    applyExistingCredit(dontApplyPercentageAgain) {
      this.serverError = "";
      this.loader = true;
      // Get current user again as promo credit or discount is updated on user info
      usersApis
        .getCleanCloudCurrentUser(this.orderObj.customerID)
        .then((response) => {
          this.loader = false;
          if (!dontApplyPercentageAgain) {
            this.CCUserDiscountPercentage = response.data.discountPercentage
              ? response.data.discountPercentage
              : 0.0;

            this.grand_total =
              this.grand_total - this.CCUserDiscountPercentageValue;
            this.totalPromoDiscountApplied +=
              this.CCUserDiscountPercentageValue;
          }

          if (response.data.creditAvailable > 0) {
            this.CCUserCreditAvailable = response.data.creditAvailable
              ? response.data.creditAvailable
              : 0.0;

            // updating grand total
            if (this.grand_total >= this.CCUserCreditAvailable) {
              this.grand_total = this.grand_total - this.CCUserCreditAvailable;
              this.credit_used = this.CCUserCreditAvailable;
              this.totalPromoDiscountApplied = this.CCUserCreditAvailable;
            } else {
              this.credit_used = this.grand_total;
              this.totalPromoDiscountApplied = this.grand_total;
              this.grand_total = 0.0;
            }
          }
        })
        .catch((error) => {
          this.loader = false;
          console.log(error);
          this.serverError = error.response.data.error
            ? error.response.data.error
            : "";
        });
    },

    // Stripe get/delete payment methods
    async getPayments() {
      const uid = getCurrentUserId();

      const response = (await usersApis.getWallets(uid)).data;
      if (response) {
        this.payments_methods = response.data ? response.data : "";
      }
      this.loader = false;
    },
    changePaymentMethod(paymentMethod) {
      if (paymentMethod == -1) {
        this.orderObj.should_create_new_stripe = true;

          this.orderObj.card_number = "";
        this.orderObj.name = "";
        this.orderObj.card_expiry = "";
        this.orderObj.card_cvv = "";
      } else {
        console.log(paymentMethod);
        this.orderObj.card_number = "************" + paymentMethod.card.last4;
        this.orderObj.name = "****";
        this.orderObj.card_expiry =
          paymentMethod.card.exp_month + "/" + paymentMethod.card.exp_year;
        // this.orderObj.card_expiry = "****";
        this.orderObj.card_cvv = "***";
        this.orderObj.should_create_new_stripe = false;
      }
    },
    // deleteModal(id) {
    //   this.deleted_id = id;

    //   var myModal = new bootstrap.Modal(
    //     document.getElementById("delete_order")
    //   );
    //   myModal.show();
    // },
    async deleteWallet() {
      console.log("dddd");
      this.loader = true;

      await usersApis.deleteWallet(this.deleted_id);

      this.deleted_id = null;
      this.getPayments();
      var myModal = new bootstrap.Modal(
        document.getElementById("delete_order")
      );
      myModal.hide();

      $("body").removeClass("modal-open");
      $(".fade").removeClass("show");
      $("body").css("padding-right", "0px");

      setTimeout(() => {
        this.loader = false;
      }, 1000);
    },
  },
  async created() {
    this.dry_clean_default_min = parseFloat(
      JSON.parse(localStorage.getItem("min_dry_clean_price"))
    );
    this.tailoring_default_min = parseFloat(
      JSON.parse(localStorage.getItem("min_tailoring_price"))
    );
    // console.log("default min", this.dry_clean_default_min);

    if (this.$store.state.cart_products) {
      const data = this.$store.state.cart_products;
      this.setData(data);
      if (
        !data.tailoring_products.length ||
        !data.wash_products.length ||
        !data.dry_clean_products.length
      ) {
        this.getLocal();
      }
    }

    this.getTiming();

    // setting products quantity
    this.settingQuantiy();
    this.getProducts();

    if (localStorage.getItem("wash_same_day_delivery")) {
      this.orderObj.is_wash_premium = JSON.parse(
        localStorage.getItem("wash_same_day_delivery")
      );
    }
    if (
      this.orderObj.is_wash_premium &&
      localStorage.getItem("wash_premium_charge_fee")
    ) {
      this.orderObj.wash_premium_fee = parseFloat(
        JSON.parse(localStorage.getItem("wash_premium_charge_fee"))
      );
    }

    this.given_areas = webSettingsApis.getAreasPostalCodes();

    // setTimeout(() => {
    //   this.loader = false;
    // }, 1000);
    this.loader = false;
    this.setMinDrycleanPriceIfApplicable();
    this.setMinTailoringPriceIfApplicable();

    /** Check postal codes of a user's account. Its setting in Data by default */
    this.checkPostal("pickup");
    this.checkPostal("delivery");

    this.applyExistingCredit(false);

    this.getPayments();
  },

  filters: {
    formatDate: function (value) {
      if (value) {
        return moment(String(value)).format("dddd, MMMM Do YYYY");
      }
    },
  },
};
</script>

<style scoped>
.payment_holder textarea {
  display: block !important;
}
.margin_agree {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/cart.vue